import { QA_NAME_EXPORT_BTN } from '../../../constants/qa'
import Button from '../../Button'

import * as styles from './TableExportButton.module.css'

import ExportIcon from '../../../icons/export.svg'

function TableExportButton({ className = styles.buttonExport, ...restProps }) {
  return (
    <Button.White
      {...restProps}
      beforeIconProps={{ Icon: ExportIcon }}
      className={className}
      qaName={QA_NAME_EXPORT_BTN}
    />
  )
}

export default TableExportButton
